import {
  GeckoMeasurement,
  GeckoMeasurementRange,
  GeckoMeasurementUnit,
} from 'types'

export function extractNumericString(str: string): string {
  const match = str.match(/^-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/)
  return match ? match[0] : ''
}

export function displayNominal(
  nominal: GeckoMeasurement | GeckoMeasurementRange,
  geometricUnit: GeckoMeasurementUnit,
  includeUnit: boolean = true
): string {
  if (nominal instanceof GeckoMeasurementRange) {
    return `${displayNominal(nominal.min, geometricUnit, includeUnit)} - ${displayNominal(nominal.max, geometricUnit, includeUnit)}`
  }
  const valWithUnit = geometricUnit.formatNumber({
    num: nominal.toNumber(geometricUnit),
    locale: 'en-US',
    variant: undefined,
    maximumFractionDigits: 5,
    minimumFractionDigits: 1,
  })

  return includeUnit ? valWithUnit : extractNumericString(valWithUnit)
}

export function displayWallLoss(
  minimum: GeckoMeasurement,
  nominal: GeckoMeasurement | GeckoMeasurementRange,
  geometricUnit: GeckoMeasurementUnit,
  measurementPrecision: number,
  includeUnit: boolean = true
): string {
  if (nominal instanceof GeckoMeasurementRange) {
    return `${displayWallLoss(minimum, nominal.min, geometricUnit, measurementPrecision, includeUnit)} - ${displayWallLoss(minimum, nominal.max, geometricUnit, measurementPrecision, includeUnit)}`
  }

  const standardMin = minimum
    .convertTo(geometricUnit)
    .round(measurementPrecision)
  /*
   * How this calc works:
   *  If rounded minimum is >= nominal, wall loss is 0.0
   *  Otherwise, wall loss is:
   *    (full precision nominal - rounded minimum) / full precision nominal
   * */
  const wallLossPercent = standardMin.lt(nominal)
    ? (nominal
        .convertTo(geometricUnit)
        .minus(standardMin)
        .toNumber(geometricUnit) /
        nominal.toNumber(geometricUnit)) *
      100
    : 0.0

  return wallLossPercent.toFixed(2) + (includeUnit ? '%' : '')
}

export function displayMean(
  mean: GeckoMeasurement,
  geometricUnit: GeckoMeasurementUnit,
  measurementPrecision: number,
  includeUnit: boolean = true
): string {
  const meanVal = mean.convertTo(geometricUnit).num

  const valWithUnit = geometricUnit.formatNumber({
    num: meanVal,
    locale: 'en-US',
    variant: undefined,
    maximumFractionDigits: measurementPrecision,
  })

  return includeUnit ? valWithUnit : extractNumericString(valWithUnit)
}

export function displayMin(
  minimum: GeckoMeasurement,
  geometricUnit: GeckoMeasurementUnit,
  measurementPrecision: number,
  includeUnit: boolean = true
): string {
  const minVal = minimum.convertTo(geometricUnit).num

  const valWithUnit = geometricUnit.formatNumber({
    num: minVal,
    locale: 'en-US',
    variant: undefined,
    maximumFractionDigits: measurementPrecision,
  })

  return includeUnit ? valWithUnit : extractNumericString(valWithUnit)
}
